<template>
  <div v-if="user" class="user-profile--information pt-5">
    <v-row>
      <v-col sm="12" class="d-flex">
        <v-avatar v-if="user" size="165px" color="red">
          <img :src="user.avatarThumbUrl" alt="John" />
        </v-avatar>

        <div class="pl-10 d-flex align-start flex-wrap">
          <div class="user-profile--basic">
            <ul>
              <li class="font-weight-bold">Email:</li>
              <li>
                {{ user.email }}
                <edit-email-dialog />
              </li>
            </ul>
          </div>

          <div class="user-profile--basic">
            <v-row>
              <v-col>
                <ul>
                  <li class="font-weight-bold">Joined Date:</li>
                  <li>{{ user.joinedDate }}</li>
                </ul>
              </v-col>
              <v-col>
                <ul>
                  <li class="font-weight-bold">Social media consent:</li>
                  <li v-if="user.main_profile">
                    {{ user.main_profile.share_photos_social ? 'Yes' : 'No' }}
                  </li>
                </ul>
              </v-col>
            </v-row>
          </div>

          <div class="user-profile--basic">
            <ul>
              <li class="font-weight-bold">Selected Program:</li>
              <li v-for="(row, index) in activePrograms" :key="index">
                •
                <v-icon
                  color="green lighten-2"
                  v-if="row.user_program.is_default"
                >
                  {{ icons.check }}
                </v-icon>
                <span v-html="row.name" />
                <span class="text-italize">
                  ({{ row.user_program.starts_at | formatedDate('ll') }}
                  to
                  {{ row.user_program.valid_until | formatedDate('ll') }})
                </span>
              </li>
            </ul>
          </div>

          <div class="user-profile--basic">
            <v-row>
              <v-col>
                <ul>
                  <li class="font-weight-bold">Membership:</li>
                  <li v-if="user && user.default_subscription">
                    {{ user.default_subscription.name }}
                  </li>
                </ul>
              </v-col>
              <v-col>
                <ul>
                  <li class="font-weight-bold">Membership&nbsp;Status:</li>
                  <span
                    v-if="user && user.pause_status && user.pause_status.active"
                  >
                    <li class="red--text font-weight-bold">PAUSED</li>
                    <li>
                      Start Date:&nbsp;{{
                        user.pause_status.start_date | formatedDate('ll')
                      }}
                    </li>
                    <li>
                      End Date:&nbsp;{{
                        user.pause_status.end_date | formatedDate('ll')
                      }}
                    </li>
                    <li>
                      Justification:&nbsp;{{ user.pause_status.justification }}
                    </li>
                  </span>
                  <span v-else-if="user && user.current_user_subscription">
                    <li :class="membershipStatusClass">
                      {{ membershipStatusLabel }}
                    </li>
                  </span>
                  <li v-else class="grey--text">-</li>
                </ul>
              </v-col>
            </v-row>
          </div>
          <div class="user-profile--basic"></div>
          <div class="user-profile--basic">
            <v-row>
              <v-col>
                <ul>
                  <li class="font-weight-bold">Age:</li>
                  <li v-if="user">
                    {{ user.age }} years old <edit-user-age-dialog />
                  </li>
                </ul>
              </v-col>
              <v-col>
                <ul>
                  <li class="font-weight-bold">Pregnancy-Safe:</li>
                  <li v-if="user && user.main_profile">
                    {{ user.main_profile.pregnancy_type | pregnancyLabels }}
                  </li>
                </ul>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-divider class="my-5" />

    <v-row>
      <v-col cols="12" sm="12">
        <!-- <div> -->
        <div>
          <v-row>
            <v-col>
              <div class="d-flex justify-space-between align-center flex-wrap">
                <h1 class="headline primary--text">
                  Main Profile Data

                  <span v-if="user.main_profile && hasProgramms">
                    <edit-user-profile-dialog
                      :profile="user.main_profile"
                      :update-profile-api="updateUserMainProfile"
                    />
                  </span>
                </h1>
              </div>
            </v-col>
          </v-row>

          <v-row v-if="user.main_profile && hasProgramms">
            <v-col cols="12" sm="3">
              <h1 class="subtitle-2 font-weight-bold">
                Current Goal
              </h1>

              <p class="body-1 primary--text">
                {{ user.main_profile.target_goal | readableEnums(targetGoals) }}
              </p>
            </v-col>

            <v-col cols="12" sm="3">
              <h1 class="subtitle-2 font-weight-bold">
                Body type
              </h1>

              <p class="body-1 primary--text">
                {{ user.main_profile.body_type | readableEnums(bodyTypes) }}
              </p>
            </v-col>

            <v-col cols="12" sm="3">
              <h1 class="subtitle-2 font-weight-bold">
                Physical Activity
              </h1>

              <p class="body-1 primary--text">
                {{
                  user.main_profile.physical_activity
                    | readableEnums(physicalActivities)
                }}
              </p>
            </v-col>

            <v-col cols="12" sm="3">
              <h1 class="subtitle-2 font-weight-bold">
                Workout Frequencies
              </h1>

              <p class="body-1 primary--text">
                {{
                  user.main_profile.workout_frequency
                    | readableEnums(workoutFrequencies)
                }}
              </p>
            </v-col>

            <v-col cols="12" sm="3">
              <h1 class="subtitle-2 font-weight-bold">
                Macro Split
              </h1>

              <p class="body-1 primary--text">
                {{ user.main_profile.macro_split | readableEnums(bodyTypes) }}
              </p>
            </v-col>

            <v-col cols="12" sm="3">
              <h1 class="subtitle-2 font-weight-bold">
                Restrictions
              </h1>

              <p class="body-1 primary--text">
                {{
                  user.main_profile.restrictions | readableEnums(restrictions)
                }}
              </p>
            </v-col>
          </v-row>

          <v-row class="mt-10" v-if="user.main_profile">
            <v-col cols="12" sm="3">
              <h1 class="subtitle-2 font-weight-bold">
                Height
              </h1>

              <p class="body-1 primary--text">
                {{ user.main_profile.height }} cm
              </p>
            </v-col>

            <v-col cols="12" sm="3">
              <h1 class="subtitle-2 font-weight-bold">
                Weight
              </h1>

              <p class="body-1 primary--text">
                {{ user.main_profile.weight }} kg
              </p>
            </v-col>

            <v-col cols="12" sm="3">
              <h1 class="subtitle-2 font-weight-bold">
                Chest
              </h1>

              <p class="body-1 primary--text">
                {{ user.main_profile.chest }} cm
              </p>
            </v-col>

            <v-col cols="12" sm="3">
              <h1 class="subtitle-2 font-weight-bold">
                Waist
              </h1>

              <p class="body-1 primary--text">
                {{ user.main_profile.waist }} cm
              </p>
            </v-col>

            <v-col cols="12" sm="3">
              <h1 class="subtitle-2 font-weight-bold">
                Hips
              </h1>

              <p class="body-1 primary--text">{{ user.main_profile.hip }} cm</p>
            </v-col>

            <v-col cols="12" sm="3">
              <h1 class="subtitle-2 font-weight-bold">
                Arms
              </h1>

              <p class="body-1 primary--text">
                {{ user.main_profile.arms }} cm
              </p>
            </v-col>

            <v-col cols="12" sm="3">
              <h1 class="subtitle-2 font-weight-bold">
                Legs
              </h1>

              <p class="body-1 primary--text">
                {{ user.main_profile.legs }} cm
              </p>
            </v-col>
          </v-row>

          <no-list
            v-if="!user.main_profile && !hasProgramms"
            details="No Questionnaire Data"
          />
        </div>
      </v-col>
    </v-row>

    <v-row v-if="user.email">
      <v-col cols="12" class="d-flex">
        <delete-user-data-dialog
          class="ml-auto"
          @user-deleted="onUserDeleted"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import _ from 'lodash'

import NoList from '@/components/elements/NoList'
import EditEmailDialog from '../components/EditEmailDialog'
import EditUserAgeDialog from '../components/EditUserAgeDialog'
import EditUserProfileDialog from '../components/EditUserProfileDialog'
import DeleteUserDataDialog from '../components/DeleteUserDataDialog'
import { mdiCheckCircle } from '@mdi/js'
import Event from '@/services/eventBus'

export default {
  name: 'UserPersonalInformationTab',

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    EditEmailDialog,
    EditUserProfileDialog,
    EditUserAgeDialog,
    DeleteUserDataDialog,
    NoList,
  },

  data() {
    return {
      icons: {
        check: mdiCheckCircle,
      },
    }
  },

  computed: {
    ...mapState({
      bodyTypes: (state) => state.meals.extra.bodyTypes,
      physicalActivityTypes: (state) =>
        state.users.extra.types.physicalActivities,
      restrictions: (state) => state.users.extra.types.restrictions,
      targetGoals: (state) => state.users.extra.types.targetGoals,
      workoutFrequencies: (state) => state.users.extra.types.workoutFrequencies,
      physicalActivities: (state) => state.users.extra.types.physicalActivities,

      user: (state) => state.users.selectedUser,
      programs: (state) => state.users.allUserPrograms,
      selectedProgram: (state) => state.users.selectedUserProgram,
    }),

    hasProgramms() {
      return _.size(this.programs) > 0
    },

    activePrograms() {
      if (!this.programs) return []
      return this.programs.filter(
        (program) => program.user_program && program.user_program.is_default
      )
    },

    membershipStatusLabel() {
      if (!this.user || !this.user.current_user_subscription) return ''
      const status = this.user.current_user_subscription.status
      if (status === 'active') return 'Active'
      if (status === 'set to expire') return 'Set to expire'
      if (status === 'expired') return 'Expired'
      return status
    },

    membershipStatusClass() {
      if (!this.user || !this.user.current_user_subscription) return ''
      const status = this.user.current_user_subscription.status
      if (status === 'active') return 'green--text'
      if (status === 'set to expire') return 'orange--text'
      if (status === 'expired') return 'red--text'
      return ''
    },
  },

  methods: {
    ...mapActions({
      updateUserMainProfile: 'users/updateUserMainProfile',
    }),

    onUserDeleted() {
      // Reload user profile to reflect the deleted state
      Event.$emit('reload-user-profile')
    },
  },
}
</script>

<style lang="scss">
.user-profile {
  &--basic {
    width: 50%;
    padding: 0 10px 0 10px;
  }

  ul {
    padding-left: 0;
    list-style: none;

    li {
      color: var(--v-primary-base) !important;
    }
  }

  .questionnaire {
    &--item {
      width: 25%;
    }

    &--nodata {
      height: 200px;
    }
  }
}
</style>
